<template>
    <div id="app">
        <offline @detected-condition="checarOnline"/>
        <transition :name="transitionName">
            <router-view></router-view>
        </transition>
        <about-screen v-if="about"/>
        <help-screen v-if="help"/>
    </div>
</template>

<script>
    import AboutScreen from '@/components/AboutScreen';
    import HelpScreen from '@/components/HelpScreen';
    import Offline from 'v-offline';

    export default {
        name: 'app',
        components: {AboutScreen, HelpScreen, Offline},
        data() {
            return {
                about: false,
                help: false,
                transitionName: 'none'
            }
        },
        metaInfo: {
            title: 'Eu odeio comunicação não-violenta'
        },
        methods: {
            toggleAboutScreen() {
                this.about = !this.about;
            },
            toggleHelpScreen() {
                this.help = !this.help;
            },
            checarOnline(e) {
                this.$store.commit('setOnline', e)
            }
        },
        watch: {
            '$route'(to) {
                this.transitionName = ((to.name === 'EndingScreen') || (to.name === 'ExtraScreen')) ? this.transitionName = 'fade-screen' : this.transitionName = 'none'
            }
        }
    }
</script>

<!--suppress CssUnusedSymbol -->
<style>
    body {
        background: #041221;
    }

    @font-face {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        src: url('assets/Roboto-Bold.ttf');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }

    .titulo-jogo {
        font-family: 'Roboto', sans-serif;
        font-size: 30px !important;
        /*display: inline;*/
        /*background: #fff;*/
        /*padding: 5px 10px;*/
    }

    .fade-screen-enter-active, .fade-screen-leave-active {
        transition: opacity 0.5s ease-out;
    }

    .fade-screen-enter, .fade-screen-leave-to,
    .fade-2s-enter, .fade-2s-leave-to {
        opacity: 0;
    }

    .fade-2s-enter-active, .fade-2s-leave-active {
        transition: opacity 2s;
    }
</style>
